import { render, staticRenderFns } from "./Accreditations.vue?vue&type=template&id=c1c7f906&scoped=true&"
import script from "./Accreditations.vue?vue&type=script&lang=js&"
export * from "./Accreditations.vue?vue&type=script&lang=js&"
import style0 from "./Accreditations.vue?vue&type=style&index=0&id=c1c7f906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c7f906",
  null
  
)

export default component.exports